import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {TextModel} from "models/Text"
import connect from "./connect"

export interface SortInputProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    text: TextModel
    toggleDropdown: () => void
}

export const SortInput = memo(({templating, toggleDropdown, text}: SortInputProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <ComponentName
            id="desktop-sort-select-label"
            htmlFor="desktop-sort-select-input"
            toggleDropdown={toggleDropdown}
            text={text}
        />
    )
})
SortInput.displayName = "SortInput"

export default connect(SortInput)
